KROWN.saveToSessionStorage = () => {
  const el = document.getElementById('cartSpecialInstructions');
  if (!el) return;
  sessionStorage.setItem('cartSpecialInstructions', el.value);
}

KROWN.loadFromSessionStorage = () => {
  const el = document.getElementById('cartSpecialInstructions');
  if (!el) return;
  const savedInstructions = sessionStorage.getItem('cartSpecialInstructions');
  if (savedInstructions) {
    el.value = savedInstructions;
  }
}

const cartInstructionsEl = document.getElementById('cartSpecialInstructions');
if (cartInstructionsEl) {
  cartInstructionsEl.addEventListener('input', KROWN.saveToSessionStorage);
}

document.addEventListener('DOMContentLoaded', KROWN.loadFromSessionStorage);